// Copyright 2022-2026 - Hewlett Packard Enterprise Company

import type React from 'react';
import { Spinner } from 'grommet';
import type { SpinnerExtendedProps } from 'grommet';

interface Props extends SpinnerExtendedProps {
  message?: string;
}

// Grommet types Spinner off BoxProps rather than BoxExtendedProps, so the DOM
// attributes it forwards are missing from its props.
const A11ySpinner = Spinner as React.FC<
  SpinnerExtendedProps & React.AriaAttributes & { role?: string }
>;

const LoadingSpinner: React.FC<Props> = ({ message, ...rest }) => (
  <A11ySpinner
    role="status"
    aria-label={message || 'Loading'}
    message={message || 'Loading'}
    {...rest}
  />
);

export default LoadingSpinner;
